import Editor from "./src/Editor"

export default Editor
